import { useState } from "react";
import toast from "react-hot-toast";
import "./contactUs.css";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";

export function ContactUsPage() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const apiUrl = process.env.REACT_APP_API_URL;

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));
  };
  const navigate = useNavigate();
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${apiUrl}/contact-us`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: formData.InputName,
          email: formData.InputEmail,
          subject: formData.InputSubject,
          message: formData.InputArea,
        }),
      });
      const result = await response.json();

      if (!response.ok) {
        toast.error(result.message);
      }
      if (response.ok) {
        navigate("/contact/thankyou");
      }
      // toast.success(result.message || "Message sent successfully!");
      setFormData({
        InputName: "",
        InputEmail: "",
        InputSubject: "",
        InputArea: "",
      });
    } catch (error) {
      toast.error(error.message || "Something went wrong.");
    }
  };

  return (
    <>
      <Helmet>
        <title>Contact Us</title>
        <link rel="canonical" href="https://yuvaquest.com/contact" />
        <meta
          name="description"
          content="Have questions or feedback? Contact the Yuva Quest team today-we’re here to help you explore Indian culture and heritage."
        />
      </Helmet>
      <div>
        <div className="my_custom_section">
          <h2 className="webUi">Contact Us</h2>
        </div>
        <form
          onSubmit={handleSubmit}
          className="formdiv container card shadow-lg p-4 mt-4 mb-4 formContact"
        >
          <div className="form-group pb-2">
            <label htmlFor="InputName" className="webUi">
              Your name
            </label>
            <input
              type="text"
              className="form-control webUi"
              id="InputName"
              value={formData.InputName}
              onChange={handleChange}
              required
              maxLength={30}
            />
          </div>
          <div className="form-group pb-2">
            <label htmlFor="InputEmail" className="webUi">
              Your email
            </label>
            <input
              type="email"
              className="form-control webUi"
              id="InputEmail"
              value={formData.InputEmail}
              onChange={handleChange}
              required
              maxLength={30}
            />
          </div>
          <div className="form-group pb-2">
            <label htmlFor="InputSubject" className="webUi">
              Subject
            </label>
            <input
              type="text"
              className="form-control webUi"
              id="InputSubject"
              value={formData.InputSubject}
              onChange={handleChange}
              required
              maxLength={100}
            />
          </div>
          <div className="form-group pb-2">
            <label htmlFor="InputArea" className="webUi">
              Your message
            </label>
            <textarea
              className="form-control webUi"
              id="InputArea"
              rows="5"
              value={formData.InputArea}
              onChange={handleChange}
              maxLength={200}
            />
          </div>
          <button type="submit" className="FormSubmitBtn btn btn-primary">
            <label className="webUi">Submit</label>
          </button>
        </form>
      </div>
    </>
  );
}
